module.exports = __webpack_public_path__ + "media/images/course/2-cefcfcd40abe3d7a663b51c345f86de8.png";